// extracted by mini-css-extract-plugin
module.exports = {"container":"section_container__wH_ov","theme":"section_theme__krwgB","content":"section_content__TBHLs","video":"section_video__TVZFl","videoWrapper":"section_videoWrapper__lVK54"};